import React, { useCallback, useEffect, useState } from "react";
import MenuDocTemplate from "../../components/templates/clientes/MenuDocTemplate";
import Heading from "../../components/atoms/Heading";
import { GET_ENTERPRISES_ADMIN, GET_ENTERPRISE_BY_ACCOUNTANT, GET_ENTERPRISE_BY_USER } from "../../api/apiEmpresas";
import { GET_ACCOUNTANTS_BY_ADMIN_ID } from "../../api/apiAdmin";
import { useSession } from "../../context/SessionContext";
import { useParams } from "react-router-dom";
import { PropagateLoader } from "react-spinners";

const MenuDoc = () => {
    const params = useParams();
    const { id } = params;
    const { user } = useSession();
    const [empresaValida, setEmpresaValida] = useState(false);
    const [loading, setLoading] = useState(true);

    const checkEmpresaValida = useCallback(async () => {
        const empresaId = Number(id);

        const hasEmpresa = (empresas) =>
            empresas?.some((empresa) => empresa?.id === empresaId);

        try {
            if (!user) return;

            switch (user.role) {
                case "Client": {
                    const empresas = await GET_ENTERPRISE_BY_USER(user.id);
                    return setEmpresaValida(hasEmpresa(empresas));
                }
                case "Accountant": {
                    const empresas = await GET_ENTERPRISE_BY_ACCOUNTANT(user.roleInfo?.id);
                    return setEmpresaValida(hasEmpresa(empresas));
                }
                case "Admin": {
                    if (user.roleInfo?.isSuperAdmin) {
                        return setEmpresaValida(true);
                    }

                    const empresasAdmin = await GET_ENTERPRISES_ADMIN(user.roleInfo?.id);
                    if (hasEmpresa(empresasAdmin)) return setEmpresaValida(true);

                    const accountants = await GET_ACCOUNTANTS_BY_ADMIN_ID(user.roleInfo?.id);

                    for (const accountant of accountants) {
                        const empresas = await GET_ENTERPRISE_BY_ACCOUNTANT(accountant.id);
                        if (hasEmpresa(empresas)) {
                            return setEmpresaValida(true);
                        }
                    }

                    return setEmpresaValida(false);
                }
                default:
                    return setEmpresaValida(false);
            }
        } catch (error) {
            console.error("Error al validar empresa:", error);
        } finally {
            setLoading(false);
        }
    }, [user, id]);

    useEffect(() => {
        checkEmpresaValida();
    }, [checkEmpresaValida]);

    return(
        <div>
            {loading ? 
                <div className="flex w-full h-full justify-center items-center">
                    <PropagateLoader color="red" />
                </div>
            :
                (!empresaValida ?
                    <div className="w-full h-full flex justify-center items-center">
                        <Heading text="Elige una empresa de tu dashboard" color="red" />
                    </div>
                :
                    <MenuDocTemplate/>
                )
            }
        </div>
    );
};

export default MenuDoc;
